// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__rNtOU","search":"Settings_search___9Q3z","filter":"Settings_filter__wN9gK"};